import * as Yup from 'yup';

import { ERROR_MESSAGE } from 'constants/message';

export const requireEmailValidation = Yup.string().required();

export const requirePasswordValidation = Yup.string().min(6).required();
export const confirmedPasswordValidation = Yup.string()
  .min(6)
  .oneOf([Yup.ref('password')], ERROR_MESSAGE.CONFIRMED_PASSWORD_NOT_MATCHING)
  .required();
